export const mockDashboardData = {
    total_pascos: 10,
    total_question_chunks: 247,
    status_breakdown: {
        completed: 5,
        pending: 2,
        processing: 2,
        failed: 1,
    },
    timestamp: "2025-10-10T18:53:25.327950",
}

export const mockTasks = [
    {
        task_id: "4a47473a-5410-464e-9b31-920e894a2eea",
        status: "completed",
        pasco_id: "dc95a887-af9d-42ff-8645-8016f28304c9",
        error_message: null,
        attempt_count: 0,
        created_at: "2025-10-07T22:56:28.038564",
        updated_at: "2025-10-08T14:50:03.754209",
    },
]

export const mockUsers = [
    {
        user_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
        name: "Sarah Johnson",
        email: "sarah.johnson@example.com",
        role: "Admin",
        status: "active" as const,
        last_login: "2025-10-10T16:30:00.000000",
        created_at: "2025-01-15T10:00:00.000000",
    },
    {
        user_id: "b2c3d4e5-f6a7-8901-bcde-f12345678901",
        name: "Michael Chen",
        email: "michael.chen@example.com",
        role: "Editor",
        status: "active" as const,
        last_login: "2025-10-10T14:15:00.000000",
        created_at: "2025-02-20T09:30:00.000000",
    },
    {
        user_id: "c3d4e5f6-a7b8-9012-cdef-123456789012",
        name: "Emily Rodriguez",
        email: "emily.rodriguez@example.com",
        role: "Viewer",
        status: "active" as const,
        last_login: "2025-10-09T18:45:00.000000",
        created_at: "2025-03-10T11:20:00.000000",
    },
    {
        user_id: "d4e5f6a7-b8c9-0123-def1-234567890123",
        name: "James Wilson",
        email: "james.wilson@example.com",
        role: "Editor",
        status: "inactive" as const,
        last_login: "2025-09-28T12:00:00.000000",
        created_at: "2025-04-05T14:10:00.000000",
    },
    {
        user_id: "e5f6a7b8-c9d0-1234-ef12-345678901234",
        name: "Lisa Anderson",
        email: "lisa.anderson@example.com",
        role: "Viewer",
        status: "suspended" as const,
        last_login: "2025-09-15T09:20:00.000000",
        created_at: "2025-05-12T16:45:00.000000",
    },
]

export const mockRoles = [
    {
        role_id: "role-1a2b3c4d-5e6f-7890-abcd-ef1234567890",
        role_name: "Admin",
        description: "Full system access with all permissions",
        permissions: ["read", "write", "delete", "manage_users", "manage_roles", "view_analytics"],
        user_count: 1,
        created_at: "2025-01-01T00:00:00.000000",
    },
    {
        role_id: "role-2b3c4d5e-6f7a-8901-bcde-f12345678901",
        role_name: "Editor",
        description: "Can create and edit content, view analytics",
        permissions: ["read", "write", "view_analytics"],
        user_count: 2,
        created_at: "2025-01-01T00:00:00.000000",
    },
    {
        role_id: "role-3c4d5e6f-7a8b-9012-cdef-123456789012",
        role_name: "Viewer",
        description: "Read-only access to content and analytics",
        permissions: ["read", "view_analytics"],
        user_count: 2,
        created_at: "2025-01-01T00:00:00.000000",
    },
]

export const mockHealthData = {
    status: "healthy" as const,
    timestamp: "2025-10-10T19:29:33.814626",
    services: {
        pinecone: "healthy" as const,
        database: "healthy" as const,
        api: "healthy" as const,
    },
}

export const getTotalPermissions = () => {
    const allPermissions = mockRoles.flatMap((role) => role.permissions)
    return new Set(allPermissions).size
}

export const getAllPermissions = () => {
    const allPermissions = mockRoles.flatMap((role) => role.permissions)
    return Array.from(new Set(allPermissions))
}

export const getPermissionsWithRoles = () => {
    const permissionsMap = new Map<
        string,
        { name: string; description: string; roleCount: number; roles: string[] }
    >()

    const permissionDescriptions: Record<string, string> = {
        read: "View and read content and data",
        write: "Create and edit content",
        delete: "Remove content and data",
        manage_users: "Manage user accounts and settings",
        manage_roles: "Create and modify roles and permissions",
        view_analytics: "Access analytics and reporting features",
    }

    mockRoles.forEach((role) => {
        role.permissions.forEach((permission) => {
            if (!permissionsMap.has(permission)) {
                permissionsMap.set(permission, {
                    name: permission,
                    description: permissionDescriptions[permission] || "No description available",
                    roleCount: 0,
                    roles: [],
                })
            }
            const permData = permissionsMap.get(permission)!
            permData.roleCount++
            permData.roles.push(role.role_name)
        })
    })

    return Array.from(permissionsMap.values())
}

export const mockPascos = [
    {
        id: "dc95a887-af9d-42ff-8645-8016f28304c9",
        courseCode: "CS101",
        courseName: "Introduction to Computer Science",
        path: "https://example-bucket.s3.amazonaws.com/pascos/2024-2025/cs101-introduction-to-computer-science.pdf",
        academicYear: "2024/2025",
        semester: 1,
        level: 100,
        department: "Computer Science",
        isApproved: true,
        processingStatus: "completed" as const,
        createdAt: "2025-10-07T22:56:28.038564",
        uploadedByUserId: "a1b2c3d4-e5f6-7890-abcd-ef1234567890", // Sarah Johnson (Admin)
    },
    {
        id: "a1b2c3d4-e5f6-7890-1234-567890abcdef",
        courseCode: "MATH201",
        courseName: "Calculus II",
        path: "https://example-bucket.s3.amazonaws.com/pascos/2024-2025/math201-calculus-ii.pdf",
        academicYear: "2024/2025",
        semester: 2,
        level: 200,
        department: "Mathematics",
        isApproved: true,
        processingStatus: "completed" as const,
        createdAt: "2025-09-15T10:30:00.000000",
        uploadedByUserId: "b2c3d4e5-f6a7-8901-bcde-f12345678901", // Michael Chen (Editor)
    },
    {
        id: "b2c3d4e5-f6a7-8901-2345-678901bcdefg",
        courseCode: "PHYS301",
        courseName: "Quantum Mechanics",
        path: "https://example-bucket.s3.amazonaws.com/pascos/2024-2025/phys301-quantum-mechanics.pdf",
        academicYear: "2024/2025",
        semester: 1,
        level: 300,
        department: "Physics",
        isApproved: false,
        processingStatus: "pending" as const,
        createdAt: "2025-10-09T14:20:00.000000",
        uploadedByUserId: "a1b2c3d4-e5f6-7890-abcd-ef1234567890", // Sarah Johnson (Admin)
    },
    {
        id: "c3d4e5f6-a7b8-9012-3456-789012cdefgh",
        courseCode: "ENG102",
        courseName: "English Composition",
        path: "https://example-bucket.s3.amazonaws.com/pascos/2024-2025/eng102-english-composition.pdf",
        academicYear: "2024/2025",
        semester: 2,
        level: 100,
        department: "English",
        isApproved: true,
        processingStatus: "processing" as const,
        createdAt: "2025-10-08T09:15:00.000000",
        uploadedByUserId: "d4e5f6a7-b8c9-0123-def1-234567890123", // James Wilson (Editor)
    },
    {
        id: "d4e5f6a7-b8c9-0123-4567-890123defghi",
        courseCode: "BIO401",
        courseName: "Molecular Biology",
        path: "https://example-bucket.s3.amazonaws.com/pascos/2023-2024/bio401-molecular-biology.pdf",
        academicYear: "2023/2024",
        semester: 2,
        level: 400,
        department: "Biology",
        isApproved: true,
        processingStatus: "completed" as const,
        createdAt: "2025-08-20T16:45:00.000000",
        uploadedByUserId: "b2c3d4e5-f6a7-8901-bcde-f12345678901", // Michael Chen (Editor)
    },
    {
        id: "e5f6a7b8-c9d0-1234-5678-901234efghij",
        courseCode: "CHEM202",
        courseName: "Organic Chemistry",
        path: "https://example-bucket.s3.amazonaws.com/pascos/2024-2025/chem202-organic-chemistry.pdf",
        academicYear: "2024/2025",
        semester: 1,
        level: 200,
        department: "Chemistry",
        isApproved: false,
        processingStatus: "failed" as const,
        createdAt: "2025-10-05T11:00:00.000000",
        uploadedByUserId: "a1b2c3d4-e5f6-7890-abcd-ef1234567890", // Sarah Johnson (Admin)
    },
    {
        id: "f6a7b8c9-d0e1-2345-6789-012345fghijk",
        courseCode: "HIST301",
        courseName: "Modern World History",
        path: "https://example-bucket.s3.amazonaws.com/pascos/2024-2025/hist301-modern-world-history.pdf",
        academicYear: "2024/2025",
        semester: 1,
        level: 300,
        department: "History",
        isApproved: true,
        processingStatus: "completed" as const,
        createdAt: "2025-09-28T13:30:00.000000",
        uploadedByUserId: "d4e5f6a7-b8c9-0123-def1-234567890123", // James Wilson (Editor)
    },
    {
        id: "a7b8c9d0-e1f2-3456-7890-123456ghijkl",
        courseCode: "ECON101",
        courseName: "Principles of Economics",
        path: "https://example-bucket.s3.amazonaws.com/pascos/2024-2025/econ101-principles-of-economics.pdf",
        academicYear: "2024/2025",
        semester: 2,
        level: 100,
        department: "Economics",
        isApproved: false,
        processingStatus: "pending" as const,
        createdAt: "2025-10-10T08:00:00.000000",
        uploadedByUserId: "b2c3d4e5-f6a7-8901-bcde-f12345678901", // Michael Chen (Editor)
    },
    {
        id: "b8c9d0e1-f2a3-4567-8901-234567hijklm",
        courseCode: "PSY201",
        courseName: "Cognitive Psychology",
        path: "https://example-bucket.s3.amazonaws.com/pascos/2023-2024/psy201-cognitive-psychology.pdf",
        academicYear: "2023/2024",
        semester: 1,
        level: 200,
        department: "Psychology",
        isApproved: true,
        processingStatus: "completed" as const,
        createdAt: "2025-07-10T15:20:00.000000",
        uploadedByUserId: "a1b2c3d4-e5f6-7890-abcd-ef1234567890", // Sarah Johnson (Admin)
    },
    {
        id: "c9d0e1f2-a3b4-5678-9012-345678ijklmn",
        courseCode: "CS401",
        courseName: "Machine Learning",
        path: "https://example-bucket.s3.amazonaws.com/pascos/2024-2025/cs401-machine-learning.pdf",
        academicYear: "2024/2025",
        semester: 1,
        level: 400,
        department: "Computer Science",
        isApproved: true,
        processingStatus: "processing" as const,
        createdAt: "2025-10-06T12:45:00.000000",
        uploadedByUserId: "b2c3d4e5-f6a7-8901-bcde-f12345678901", // Michael Chen (Editor)
    },
]
